import './scss/_form-search.scss'
import {FormSearchComponent} from './components/FormSearchComponent'

const FormSearchPackage = {
    name: 'UIFormSearch',
    configure: function(config) {
        config.addComponent('UIFormSearch', FormSearchComponent, false, 'form-search')

        config.addLabel('formsearch.item-exists-label', {
            en: 'The name already exists',
            sv: 'Namnet är redan tillagt'
        })

        config.addLabel('formsearch.item-exists-description', {
            en: 'The name you are trying to add already exists in the list',
            sv: 'Namnet du försöker lägga till finns redan i listan'
        })

        config.addLabel('Create', {
            sv: 'Skapa'
        })
    }
}

export {FormSearchPackage}
